import { render } from "./component-type-form.vue?vue&type=template&id=a98cde5e"
import script from "./component-type-form.vue?vue&type=script&lang=js"
export * from "./component-type-form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__